import Head from 'next/head';

interface ITwitterProps {
  twDesc: string;
  twTitle: string;
  twImageUrl: string;
  twImageAlt: string;
}

export default function Twitter({ twDesc, twTitle, twImageUrl, twImageAlt }: ITwitterProps) {
  return (
    <Head>
      <meta name="twitter:card" content={'summary_large_image'} />{' '}
      {/* Would we want any different type of card? */}
      <meta name="twitter:title" content={twTitle} />
      <meta name="twitter:description" content={twDesc} />
      <meta name="twitter:image" content={twImageUrl} />
      <meta name="twitter:image:alt" content={twImageAlt} />
    </Head>
  );
}
